/* global swal, _, angular*/
import './style.less';
import template from './template.html';

export default function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      text: '=',
      height: '<'
    },
    template: template,
    controller: function($scope) {
      'ngInject';

      $scope.required = true;

      const options = {
        height: $scope.height || 200,
        toolbar: [
          ['edit', ['undo', 'redo']],
          ['headline', ['style']],
          ['style', ['bold', 'italic', 'underline', 'superscript', 'subscript', 'strikethrough', 'clear']],
          ['fontclr', ['color']],
          ['alignment', ['ul', 'ol', 'paragraph']],
          ['height', ['height']],
          ['table', ['table']],
          ['insert', ['link', 'picture', 'video', 'hr']],
          ['view', ['fullscreen', 'codeview']],
          ['help', ['help']]
        ],
        codemirror: {}
      };

      $scope.options = options;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/textEditor/index.js